<template>
    <v-container class="industryPerformance pl-0">
        <v-row>

            <!-- Desktop -->
            <v-col v-if="!isMobile" :cols="comparisonMode ? 6 : 12" class="d-flex flex-column"> 
                <country-picker
                    v-if="comparisonMode"
                    class="country-picker_on_industryPerformance"
                    @selectedCountry="updateMainCountry($event)"
                    :initialCountry="mainCountry"                    
                />
                <country-name-bar 
                    v-if="!comparisonMode"
                    :countryName="mainCountry.country_name"
                    class="pb-12 pl-4"
                />
                <industry-performance-scores
                    v-if="mainCountry && mainCountry.industryPerformance"
                    :country="mainCountry"
                    :key="mainCountry.iso + comparisonMode"
                    :comparisonMode="comparisonMode"
                    :sharedPage="sharedPage"
                    @page-changed="sharedPage = $event"                    
                    :duplicate="comparisonCountry.industryPerformance"
                    :singleCompare="singleCompare"
                    :class="comparisonMode ? 'comparisonPerformance' : ''"
                />
            </v-col> 
            
            <!-- Desktop + Compare -->
            <v-col v-if="comparisonMode && !isMobile" :cols="6" class="d-flex flex-column">
                <country-picker
                    class="country-picker_on_industryPerformance"
                    @selectedCountry="updateComparisonCountry($event)"
                />
                <industry-performance-scores
                    :country="comparisonCountry"
                    v-if="comparisonCountry && comparisonCountry.industryPerformance"
                    :comparisonMode="true"
                    :sharedPage="sharedPage"
                    @page-changed="sharedPage = $event"
                    :class="comparisonMode ? 'comparisonPerformance' : ''"
                />
            </v-col>
    
            <!-- Mobile -->            
            <v-col v-if="isMobile" :cols="12"> 
                <country-picker
                    class="country-picker_on_industryPerformance"
                    @selectedCountry="updateMainCountry($event)"
                    v-if="comparisonMode"
                    :initialCountry="mainCountry"
                />
                <country-name-bar 
                    :countryName="mainCountry.country_name"
                    v-if="!comparisonMode"
                    class="pb-12 pl-4"
                />
				<!-- Mobile -->            
				<v-col v-if="isMobile" :cols="12"> 
					<div v-if="comparisonMode" class="">
						<v-btn
							class="compareBackBtn mobileCompareBackBtn"
							rounded
							@click="changeCompareMode(true)"
						>
							<span class="buttonText">Back</span>
						</v-btn>
					</div>
				</v-col> 
				
                <industry-performance-scores
                    :country="mainCountry"
                    :key="mainCountry.iso + comparisonMode"
                    v-if="mainCountry && mainCountry.industryPerformance"
                    :comparisonMode="comparisonMode"
                    :sharedPage="sharedPage"
                    @page-changed="sharedPage = $event"                    
                    :duplicate="comparisonCountry.industryPerformance"
                    :singleCompare="singleCompare"
                />
            </v-col>   

            <!-- Mobile + Compare -->
            <v-col :cols="12" v-if="comparisonMode && isMobile">
                <country-picker
                    class="country-picker_on_industryPerformance"
                    @selectedCountry="updateComparisonCountry($event)"
                />  

				<!-- Mobile + Compare -->
				<v-col :cols="12" v-if="comparisonMode && isMobile">
					<div v-if="comparisonCountry && comparisonCountry.industryPerformance" class="">
						<v-btn
							class="compareBackBtn viewCountryBtn midnightButton buttonBranding_midnight mobileCompareBackBtn"
							rounded
							flat
							:ripple="false"
							@click="viewNewCountry"
						>
							<span class="buttonText">View country</span>
						</v-btn>
					</div>
				</v-col>

                <industry-performance-scores
                    :country="comparisonCountry"
                    v-if="comparisonCountry && comparisonCountry.industryPerformance"
                    :comparisonMode="true"
                    :sharedPage="sharedPage"
                    @page-changed="sharedPage = $event"
                />
            </v-col>
        </v-row>


		<v-row>
            <!-- Desktop -->
            <v-col v-if="!isMobile && comparisonMode" :cols="comparisonMode ? 6 : 12" class="d-flex flex-column mb-4"> 
                <div>
                    <v-btn
                        class="compareBackBtn midnightButton buttonBranding_midnight desktopCompareBackBtn"
                        rounded
                        @click="changeCompareMode"
                    >
                        <span class="buttonText">Back</span>
                    </v-btn>
                </div>
            </v-col> 
            
            <!-- Desktop + Compare -->
            <v-col v-if="comparisonMode && !isMobile" :cols="6" class="d-flex flex-column mb-4">
                <div v-if="comparisonCountry && comparisonCountry.industryPerformance">
                    <v-btn
                        class="compareBackBtn desktopCompareBackBtn viewCountryBtn"
                        rounded
                        @click="viewNewCountry"
                    >
                        <span class="buttonText">View country</span>
                    </v-btn>
                </div>
            </v-col>

        </v-row>


        <v-row v-if="!comparisonMode" :class="isMobile ? 'compareCountriesButtonHolderMobile' : 'compareCountriesButtonHolder'">
            <v-col>
				<compare-countries-button
				@changeCompareMode="changeCompareMode"
				/>
            </v-col>
        </v-row>
		
    </v-container>
</template>

<script lang="ts">
import {
    defineComponent
} from 'vue';

import store from '@/store/index'
import { Service as CountryService } from '@/services/countryService';

export default defineComponent({
    name : 'IndustryPerformance',
    data: () => ({
        mainCountry: {} as any,
        comparisonCountry: {} as any,
        comparisonMode: false,
        isMobile: window.innerWidth <= 900, // Initial check for mobile view
        sharedPage: 1,
        singleCompare: true
    }),
    mounted() {
        this.mainCountry = this.selectedCountry;
        window.addEventListener('resize', this.checkIfMobile);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.checkIfMobile);
    },
    computed:{
        selectedCountry(){
            return store.getters['countryStoreData/selectedCountry'];
        }
    },
    methods: {
        updateComparisonCountry(countryCode: string){
            this.comparisonCountry = CountryService.getCountryByObjectCode(countryCode);
            this.sharedPage = 1;
            this.singleCompare = false;
        },
        updateMainCountry(countryCode: string){
            this.mainCountry = CountryService.getCountryByObjectCode(countryCode);
        },
        changeCompareMode(back?: boolean){
            if(back){
                this.singleCompare = true;
            }
            this.comparisonMode = !this.comparisonMode;
            this.comparisonCountry = {};
            this.sharedPage = 1;
        },
        viewNewCountry(){
            store.dispatch('countryStoreData/setSelectedCountry', this.comparisonCountry)
            store.dispatch('stateStoreData/setMenuMode', 'risk')
        },
        checkIfMobile() {
            this.isMobile = window.innerWidth <= 900;
        }
    },
    watch:{
        mainCountry(){
            // 
        },
    }
});



</script>

<style scoped>
.country-picker_on_industryPerformance{
    position: initial;
    height: 48px;
}

.keyPerformer{
    margin-top: 40px;
    margin-bottom: 24px;
    display:flex;
    flex-direction: column;
}
.keyPerformerTitle{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #DC0028;
    font-family: 'GCO Sans', sans-serif;
}
.keyPerformerCategoryTitle{
    font-size: 24px;
    font-weight: 500;
    line-height: 28px;
    letter-spacing: -2%;
    color: #333333;
    font-family: 'GCO', sans-serif;
    padding-top: 8px;
    padding-bottom: 8px;
}
.keyPerformerCategorySummary{
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: #3C424C;
    font-family: 'GCO Sans', sans-serif;
}
.compareBackBtn{
    background-color: #2E2E2E; /* Adjust this color as needed */
    color: white;
    padding: 25px 30px;
    margin-top:10px;
    margin-bottom: 15px;
    font-size: 16px;
    display: flex;
    align-items: center;
    border-radius: 50px;
    
    /* Font */
    
    font-family: 'GCO Sans' !important;
    font-size: 16px;
    font-weight: 400;
    line-height: 20.8px;
    text-align: left;
    letter-spacing: 0.48px;
    
    text-transform: none;
    
    cursor: pointer;
    width:fit-content;

	float: left;

	&.viewCountryBtn
	{
	}

}

.desktopCompareBackBtn{
    /*position: absolute;
    bottom: 160px;*/
}

.comparisonPerformance{
    padding-top: 57px;
    padding-left: 28px;
}

.compareCountriesButtonHolder{
    /*position: sticky;
    bottom: 46px;*/
}

.compareCountriesButtonHolderMobile{
    /*position: fixed;
    bottom: 175px;*/
}

</style>